__webpack_require__.p = "https://assets.cdn.ifixit.com/Assets/scripts/";